import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '@/hooks/useAuth';

const { Content } = Layout;

/**
 * 主框架:左 Sidebar(固定 220) + 顶 Header(粘顶 62) + Content。
 *
 * Sprint44-Portal:子门户角色(enterprise/mentor/investor)隐藏 Sidebar —
 * 这些角色 canSee() 全 false sidebar 本来就是空白,占 220px 浪费屏宽;
 * Header 的应用名也改成仅子门户角色不显(品牌信息够了)。
 */
export function AppLayout() {
  const { role } = useAuth();
  const isSubportalRole =
    role === 'enterprise' || role === 'mentor' || role === 'investor';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isSubportalRole && <Sidebar />}
      <Layout style={{ marginLeft: isSubportalRole ? 0 : 220 }}>
        <Header />
        <Content
          style={{
            padding: 'var(--space-6)',
            background: 'var(--color-bg-page)',
            minHeight: 'calc(100vh - 62px)',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
